export default __webpack_public_path__ + "static/media/mark.6d51efea.svg";